import styled from 'styled-components';
import { Row } from 'antd';

import { CloudinaryImageViewModel } from '@api/index';
import theme from '@theme';

export const ImageContainer = styled.div<{ image?: CloudinaryImageViewModel }>`
  padding-bottom: 66.6%;
  background-repeat: no-repeat;
  background-image: url(${({ image }) => image?.url});
  background-position: center center;
  background-size: 100%;
  transition: all 0.8s;
`;

export const Container = styled.a`
  border: 1px solid ${({ theme }) => theme.palette.gray87};
  font-weight: 700;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    ${ImageContainer} {
      background-size: 110%;
    }
  }
`;

export const Summary = styled(Row)`
  background-color: ${theme.palette.white};
  font-weight: 700;
  padding: 18px;
  margin-left: 0px !important;
  margin-right: 0px !important;
`;

export const DetailButton = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.darkGrey};
  color: ${({ theme }) => theme.palette.darkGrey};
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  line-height: 35px;
  padding: 0 5px;
  text-align: center;
  white-space: nowrap;
  text-transform: uppercase;
  box-shadow: 0 2px 0 rgb(0 0 0 / 2%);
  transition: all 0.3s ease;

  &:hover {
    border: 1px solid ${({ theme }) => theme.palette.primaryBrand};
    background-color: ${({ theme }) => theme.palette.primaryBrand};
    color: ${({ theme }) => theme.palette.white};
  }
`;

export const TourName = styled.strong`
  font-size: 18px;
  font-weight: 700;

  word-break: break-word;
  color: ${({ theme }) => theme.palette.darkGrey};

  &:hover {
    color: ${({ theme }) => theme.palette.darkGrey};
  }
`;

export const TagLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TagLinksTitle = styled.div`
  position: relative;

  h2 {
    display: inline-block;
    line-height: 40px;
    font-size: 18px;
    font-weight: 700;
    color: ${({ theme }) => theme.palette.darkGrey};
    margin-bottom: 0;
    border-left: 5px solid #b7b9bd;
    padding: 0 10px;
    z-index: 1;
    background-color: ${({ theme }) => theme.palette.white};

    position: relative;
    z-index: 1;
  }

  &:hover {
    color: ${({ theme }) => theme.palette.darkGrey};
  }

  &:after {
    background: #b7b9bd;
    content: '';
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    right: 0;
    top: 50%;
  }
`;

export const TagLinksContent = styled.div`
  text-align: justify;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 15px;
`;

export const TagLinksList = styled.ul`
  list-style: none;
`;

export const TagLinkItem = styled.li`
  border: 1px dashed #a0a0a0;
  padding: 5px;
  margin: 0 3px 5px;
  display: inline-block;
  width: auto;
`;

export const TagLinksItem = styled.a`
  color: ${({ theme }) => theme.palette.darkGrey};
  &:hover {
    color: ${({ theme }) => theme.palette.darkGrey};
  }
`;
